<template>
    <Detail :logo-on-click="logoOnClick" show-footer>
        <template v-slot:header>
            <div class="row no-gutters" v-if="isAnalysisLoaded">
                <div class="col col-4">
                    <h4>{{ $t("buyer") }}</h4>
                    <h2>{{ analysis.name }}</h2>
                    <h3>
                        {{ $filters.upper($t("organization_id")) }}: {{ analysis.ico }}
                    </h3>
                </div>
                <div id="suppliers" class="col col-4">
                    <h4>{{ $tc("supplier", 2) }}</h4>
                    <h2 class="numeric">
                        {{ formatInteger(analysis.suppliers_count) }}
                    </h2>
                </div>
                <div id="period" class="col col-4">
                    <h4>{{ $t("period") }}</h4>
                    <h2 class="numeric">
                        {{ $filters.formatDate(analysis.start_date, "M/YYYY") }} -
                        {{ $filters.formatDate(analysis.end_date, "M/YYYY") }}
                    </h2>
                </div>
            </div>
        </template>

        <template v-slot:header_small>
            <div class="row no-gutters">
                <div class="col col-8">
                    <h2>{{ analysis.name }}</h2>
                </div>
                <div id="period" class="col col-4">
                    <h2 class="numeric">
                        {{ $filters.formatDate(analysis.start_date, "M/YYYY") }}-{{
                            $filters.formatDate(analysis.end_date, "M/YYYY")
                        }}
                    </h2>
                </div>
            </div>
        </template>

        <template v-slot:menu>
            <Menu :nav="nav" current="contracts" />
        </template>

        <template v-slot:content>
            <section id="contracts_section">
                <h4 class="mt-5 mb-3">{{ $t("overview.contracts.title") }}</h4>

                <ContractTable ref="contracts_table" :count="count_contracts" :version="version" :hash="hash"
                    :init-filter="$store.state.contractTableFilter" :start-page="$store.state.contractTablePage"
                    :per-page="$store.state.contractTablePerPage" />
            </section>
        </template>

    </Detail>
</template>

<script>
import Detail from "@/views/layouts/Detail.vue";
import Menu from "@/components/Menu.vue";
import ContractTable from "@/components/ContractTable.vue";
import formattersMixin from "@/plugins/formattersMixin.js";

export default {
    props: {
        hash: { required: true },
        version: { required: true },
    },
    name: "contracts",
    components: { Detail, ContractTable, Menu },
    mixins: [formattersMixin],
    data: function () {
        return {
            count_contracts: this.$store.state.count_contracts,
            nav: {
                risks: {
                    to: { name: this.version, params: { hash: this.hash } },
                    label: this.$t("nav.risks"),
                },
                suppliers: {
                    to: {
                        name: "suppliers",
                        params: { hash: this.hash, version: this.version },
                    },
                    label: this.$t("nav.suppliers"),
                },
                tenders: {
                    to: {
                        name: "tenders",
                        params: { hash: this.hash, version: this.version }
                    },
                    label: this.$t("nav.tenders")
                },
                contracts: {
                    to: {
                        name: "contracts",
                        params: { hash: this.hash, version: this.version }
                    },
                    label: this.$t("nav.contracts")
                }
            },
        };
    },
    computed: {
        analysis: {
            get: function () {
                return this.$store.state.analysis;
            },
            set: function (value) {
                this.$store.dispatch("setCurrentAnalysis", value);
            },
        },
        isAnalysisLoaded: function () {
            return Object.keys(this.analysis).length > 0;
        },
    },
    created: function () {
        if (!this.isAnalysisLoaded) {
            this.loadAnalysis();
        }
        else {
            this.count_contracts = this.$store.state.analysis.paid_contracts;
        }
    },
    mounted: function () {
        this.$root.$emit("set-page-title", this.$t("titleDetail", { name: this.analysis.name }))
    },
    watch: {
        analysis: function () {
            this.$root.$emit("set-page-title", this.$t("titleDetail", { name: this.analysis.name }))
        }
    },
    methods: {
        loadAnalysis: function () {
            return new Promise((resolve, reject) => {
                var self = this;

                var params = {
                    format: "json",
                };

                params[`${this.version}_hash`] = this.hash;

                this.$store.getters.api
                    .get(`${this.version}/${this.hash}/`, { params: params })
                    .then((response) => {
                        self.analysis = response.data;
                        self.$store.state.count_tenders = response.data["paid_tenders"];
                        self.$store.state.count_contracts = response.data["paid_contracts"];
                        resolve();
                    })
                    .catch((e) => {
                        reject(e);
                        self.analysis = {};
                    });
            });
        },
        logoOnClick: function () {
            this.$router.push({ name: this.version, params: { hash: this.hash } })
        }
    },
};
</script>

<style scoped lang="scss">
@import "src/scss/custom";

.premium_column {
    margin-top: 23px;
    padding-left: 10px;
}

#menu {
    margin-bottom: 50px;

    button {
        text-align: left;
        background-color: white;
        padding: 0.6rem 1.5rem;
        padding-right: 0;

        &.active {
            background-color: $background-light;
        }

        &:hover {
            background-color: $light;
        }

        &[disabled] {
            background-color: transparent;
        }

        .premium_label {
            float: right;
        }
    }
}

.risk_table {
    margin-bottom: 30px;
}
</style>
